import React, { useEffect } from 'react';
import { Col, Flex, Progress, Row, Select, Tag, Typography, Card } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTokenStats, assignPlan } from '../settings/redux/slice';

const { Title, Text } = Typography;

const PLANS = ['S', 'M', 'L', 'XL'];
const PLAN_LABELS = {
    S:  'S – Free (1 Mio.)',
    M:  'M – Standard (4 Mio.)',
    L:  'L – Professional (8 Mio.)',
    XL: 'XL – Enterprise (13 Mio.)',
};
const PLAN_COLORS = { S: 'default', M: 'blue', L: 'purple', XL: 'gold' };

const fmt = (n) => (n ?? 0).toLocaleString('de-DE');

const progressColor = (pct) => {
    if (pct >= 90) return '#cf1322';
    if (pct >= 70) return '#fa8c16';
    return '#52c41a';
};

const TokenAdmin = () => {
    const dispatch = useDispatch();
    const { tokenStats, tokenStatsLoading } = useSelector(state => state.profile);

    useEffect(() => {
        dispatch(fetchTokenStats());
    }, []);

    const handlePlanChange = (organizerId, plan) => {
        dispatch(assignPlan({ organizerId, plan }));
    };

    return (
        <Flex vertical gap={16} className='paddingY-3 paddingX-2 bg-white'>
            <Row justify='space-between' align='middle'>
                <Col>
                    <Title level={4} type='success'>KI Token-Verwaltung</Title>
                </Col>
                <Col>
                    <Text type='secondary'>Monatlicher Verbrauch aller Mandanten</Text>
                </Col>
            </Row>

            <Row gutter={[16, 16]}>
                {(tokenStats || []).map((t) => (
                    <Col key={t._id} xs={24} lg={12} xxl={8}>
                        <Card
                            size='small'
                            className='border-green'
                            title={
                                <Flex justify='space-between' align='center'>
                                    <Text strong>{t.name || '(ohne Name)'}</Text>
                                    {t.hasOwnKey
                                        ? <Tag color='cyan'>Eigener Key</Tag>
                                        : <Tag color={PLAN_COLORS[t.plan] || 'default'}>Plan {t.plan}</Tag>
                                    }
                                </Flex>
                            }
                        >
                            <Flex vertical gap={10}>
                                {t.hasOwnKey ? (
                                    <Text type='secondary'>Eigener Anthropic API-Key — kein Kontingent</Text>
                                ) : (
                                    <>
                                        <Flex justify='space-between'>
                                            <Text type='secondary'>{fmt(t.used)} / {fmt(t.limit)} Tokens</Text>
                                            <Text strong style={{ color: progressColor(t.pct) }}>{t.pct} %</Text>
                                        </Flex>
                                        <Progress
                                            percent={t.pct}
                                            strokeColor={progressColor(t.pct)}
                                            status={t.pct >= 100 ? 'exception' : 'normal'}
                                            size='small'
                                            showInfo={false}
                                        />
                                        <Flex align='center' gap={8}>
                                            <Text type='secondary' style={{ whiteSpace: 'nowrap' }}>Plan:</Text>
                                            <Select
                                                value={t.plan}
                                                size='small'
                                                style={{ width: 220 }}
                                                onChange={(val) => handlePlanChange(t.organizer, val)}
                                                loading={tokenStatsLoading}
                                                options={PLANS.map(p => ({ value: p, label: PLAN_LABELS[p] }))}
                                            />
                                        </Flex>
                                    </>
                                )}
                            </Flex>
                        </Card>
                    </Col>
                ))}

                {!tokenStatsLoading && (!tokenStats || tokenStats.length === 0) && (
                    <Col xs={24}>
                        <Text type='secondary'>Keine Mandanten gefunden.</Text>
                    </Col>
                )}
            </Row>
        </Flex>
    );
};

export default TokenAdmin;
